import { L2D_COMPLEMENTARY } from '@europrocurement/flexy-components';

export const rubFacToColor = (rubFac: string): string => {
    switch (rubFac) {
        case 'VAC':
            return L2D_COMPLEMENTARY.PURPLE;
        case 'RED':
        case 'RED2':
        case 'REI':
            return L2D_COMPLEMENTARY.ROSE;
        case 'FRN':
        case 'FRS':
            return L2D_COMPLEMENTARY.BROWN;
        case 'PUB':
        case 'PUBNS':
            return L2D_COMPLEMENTARY.BLUE;
        default:
            return 'blueGrey.main';
    }
};

type ArticleColors = {
    masked: string;
    unfacturable: string;
    default: string;
};

export const articleToColor = (
    articleFacturable: boolean,
    fMasqueCalcul: boolean,
    articleFacture: boolean,
    colors?: ArticleColors,
): string => {
    if (fMasqueCalcul) {
        return colors?.masked ?? '#ececec';
    }
    if (!articleFacturable && !articleFacture) {
        return colors?.unfacturable ?? '#f9e4d8';
    }
    return colors?.default ?? '#F6F7FA';
};

export const formatEuro = (
    amount: number,
    locale = 'fr-FR',
    currency = 'EUR',
    minMaxDecimals = 2,
): string =>
    amount.toLocaleString(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: minMaxDecimals,
        maximumFractionDigits: minMaxDecimals,
    });

export const dragHandleWidth = '35px';
export const rubriqueWidth = '100px';
export const quantiteWidth = '80px';
export const puWidth = '120px';
export const tauxWidth = '120px';
export const ttcWidth = '120px';
export const actionsWidth = '50px';
export const libelleWidth = `calc(100% - ${dragHandleWidth} - ${rubriqueWidth} - ${quantiteWidth} - ${puWidth} - ${tauxWidth} - ${ttcWidth} - ${actionsWidth})`;

export const libelleWidthMobile = `calc(100% - ${dragHandleWidth} - ${rubriqueWidth} )`;
export const quantiteWidthMobile = '15%';
export const puWidthMobile = '20%';
export const tauxWidthMobile = '20%';
export const ttcWidthMobile = '25%';
export const actionsWidthMobile = '10%';

export const rubriqueLibelle = 'Rub.';
export const quantiteLibelle = 'Qté';
export const puLibelle = 'PU';
export const tauxLibelle = 'TVA';
export const ttcLibelle = 'Total TTC';
export const libelleLibelle = `Libellé`;
